import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit } from '@angular/core';
import { AteModalRef } from '../../../services/ate-modal/ate-modal.ref';
import { FcmNotificationsService } from '../../../services/fcm-notifications/fcm-notifications.service';
import { first } from 'rxjs';

@Component({
  selector: 'app-notifications-dialog',
  templateUrl: './notifications-dialog.component.html',
  styleUrls: ['./notifications-dialog.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NotificationsDialogComponent implements OnInit {
  private readonly _modalRef = inject(AteModalRef);
  private readonly _fcmNotificationsService = inject(FcmNotificationsService);

  ngOnInit() {
    this._fcmNotificationsService.setModalShownFlag();
    this._modalRef.onCtaClick = () => this._requestNotificationPermission();
  }

  /**
   * @todo Add analytics to determine if users are getting to the native permission
   * dialog and hitting yes or no.
   */
  private _requestNotificationPermission() {
    this._fcmNotificationsService
      .registerForNotifications()
      .pipe(first())
      .subscribe({
        next: () => {
          console.log('Saved registration token successfully');
        },
        error: err => {
          console.error(err);
        }
      });

    this._modalRef.close();
  }
}
